(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lbt-cardboard-selector"] && !Shopify.designMode) return;
  try {
    
function initBoxGuides(){document.querySelectorAll('[data-box-guide]').forEach(root=>{if(root.dataset.initialized)return;root.dataset.initialized='true';let surface='raw',setup='handheld';const copy=root.querySelector('[data-box-copy]');function update(){root.querySelector('[data-box-result]').textContent=surface==='unsure'?copy.dataset.unsure:copy.getAttribute('data-'+surface+'-'+setup);const link=root.querySelector('[data-box-result-link]');link.textContent=surface==='unsure'?copy.dataset.reviewLabel:copy.dataset.viewLabel;link.href=surface==='unsure'?'/pages/submit-logo':setup==='handheld'?'#box-electric':setup==='existing'?'#box-head':'#box-press';}root.querySelectorAll('[data-box-surface],[data-box-setup]').forEach(button=>button.addEventListener('click',()=>{const kind=button.hasAttribute('data-box-surface')?'surface':'setup';if(kind==='surface')surface=button.dataset.boxSurface;else setup=button.dataset.boxSetup;root.querySelectorAll('[data-box-'+kind+']').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));update();}));root.querySelectorAll('[data-box-variant]').forEach(select=>select.addEventListener('change',()=>{select.closest('article').querySelector('[data-box-product-link]').href=select.dataset.productUrl+'&variant='+encodeURIComponent(select.value);}));});}initBoxGuides();document.addEventListener('shopify:section:load',initBoxGuides);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["legacy-blog-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('legacy-blog-carousel')) {
    customElements.define('legacy-blog-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        if (!this.track || !this.prev || !this.next) return;
        this.prev.addEventListener('click', () => this.move(-1));
        this.next.addEventListener('click', () => this.move(1));
        this.track.addEventListener('scroll', () => this.update(), { passive: true });
        this.track.addEventListener('keydown', event => {
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.move(event.key === 'ArrowRight' ? 1 : -1);
          }
        });
        this.resizeObserver = new ResizeObserver(() => this.update());
        this.resizeObserver.observe(this.track);
        requestAnimationFrame(() => this.update());
      }
      disconnectedCallback() { this.resizeObserver?.disconnect(); }
      move(direction) {
        const card = this.track.querySelector('.legacy-blog-carousel__slide');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
        const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: reduced ? 'instant' : 'smooth' });
      }
      update() {
        const max = this.track.scrollWidth - this.track.clientWidth;
        this.prev.disabled = this.track.scrollLeft <= 2;
        this.next.disabled = this.track.scrollLeft >= max - 2;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["legacy-plastic-product-enhancement"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mountEnhancement = () => {
      document.querySelectorAll('[data-lbtp-root]').forEach((root) => {
        if (root.dataset.lbtpMounted === 'true') return;

        const productSection = document.querySelector('[id^="MainProduct-"]') || document.querySelector('.product');
        const productInfo = productSection ? productSection.querySelector('.product__info-container') : null;
        const title = productInfo ? productInfo.querySelector('.product__title') : null;
        const form = productInfo
          ? productInfo.querySelector('product-form form[action*="/cart/add"]') || productInfo.querySelector('form[action*="/cart/add"]:has(.product-form__buttons)')
          : null;
        const buttons = form ? form.querySelector('.product-form__buttons') : null;
        const productForm = form ? form.closest('product-form') : null;
        const mainSection = productSection ? productSection.closest('.shopify-section') || productSection : null;

        if (!productInfo || !title || !form || !buttons || !mainSection) return;

        root.dataset.lbtpMounted = 'true';
        productSection.classList.add('lbtp-product-section');
        form.setAttribute('enctype', 'multipart/form-data');

        const intro = root.querySelector('[data-lbtp-intro]');
        const order = root.querySelector('[data-lbtp-order]');
        const after = root.querySelector('[data-lbtp-after]');
        const description = productInfo.querySelector('.product__description');
        const descriptionSection = root.querySelector('[data-lbtp-description]');
        const descriptionContent = root.querySelector('[data-lbtp-description-content]');
        const lower = root.querySelector('[data-lbtp-lower]');

        const legacyGenericHeading = Array.from(document.querySelectorAll('.shopify-section h2')).find(
          (heading) => heading.textContent.trim() === 'Precision Without Compromise'
        );
        const legacyGenericSection = legacyGenericHeading ? legacyGenericHeading.closest('.shopify-section') : null;
        if (legacyGenericSection) legacyGenericSection.remove();

        title.insertAdjacentElement('afterend', intro);
        buttons.insertAdjacentElement('beforebegin', order);

        if (productForm) {
          productForm.insertAdjacentElement('afterend', after);
        } else {
          form.insertAdjacentElement('afterend', after);
        }

        if (description && descriptionSection && descriptionContent) {
          descriptionContent.appendChild(description);
          descriptionSection.hidden = false;
          mainSection.insertAdjacentElement('afterend', descriptionSection);
          descriptionSection.insertAdjacentElement('afterend', lower);
        } else {
          mainSection.insertAdjacentElement('afterend', lower);
        }
        root.remove();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', mountEnhancement, { once: true });
    } else {
      mountEnhancement();
    }

    document.addEventListener('shopify:section:load', mountEnhancement);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
